import React from 'react';
import useChart from '../../../../hooks/generic/charts/useChart';

// Generic default options based on chart type
const defaultChartOptions = (type) => ({
  chart: { type },
  title: { text: null },
  credits: { enabled: false },
});

// Generic Chart component
const Chart = (props) => {
  const [HighchartsComponent, highchartsOptions] = useChart({
    chartOptions: {
      defaultOptions: defaultChartOptions(props.type),
      primaryOptions: props.chartOptions,
    },
    configs: props.configs,
  });

  return <HighchartsComponent {...highchartsOptions} callback={props.callbackFn} />;
};

// Specific chart components using the generic Chart component
const ColumnChart = (props) => <Chart type="column" {...props} />;
const BarChart = (props) => <Chart type="bar" {...props} />;

export { ColumnChart, BarChart };
